import * as Yup from 'yup'

export const schemaOrder = (t: (key: string) => string) => ({
  status: Yup.string().required(t('requiredMessage')),
  paymentTerm: Yup.string().required(t('requiredMessage')),
  expectedPaymentDate: Yup.string().required(t('requiredMessage')),
})
